// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__36XOS","error":"Button_error__16ZR2","success":"Button_success__1edEt","primary":"Button_primary__17VQ1","processIcon":"Button_processIcon__2wspA"};